import React, { FunctionComponent } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

interface Props {
  label: any;
  disabled?: boolean;
  color?: string;
  value?: any;
  onChange?: (e: any) => void;
}

export const MyCheckBox: FunctionComponent<Props> = ({
  label,
  disabled,
  color,
  value,
  onChange,
}) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={value}
        style={{
          color,
        }}
        onChange={onChange}
        disabled={disabled}
      />
    }
    label={label}
  />
);

MyCheckBox.defaultProps = {
  value: '',
  disabled: false,
  color: undefined,
  onChange: undefined,
};
